export default "__VITE_ASSET__0nlIlFIf__"